import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'M13 5.61 8 11 3 5.58Z';
const draw24px = 'M17,9.72l-5,5.42-5-5.42Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const TriangleDownIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'triangleDown'));
TriangleDownIcon.displayName = 'TriangleDownIcon';
TriangleDownIcon.propTypes = Icon.propTypes;
TriangleDownIcon.renderIcon = props => /*#__PURE__*/React.createElement(TriangleDownIcon, props);
export default TriangleDownIcon;
//# sourceMappingURL=TriangleDownIcon.js.map